import { ModifyUserAlarmTypeGroupsPayload } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateUserAlarmTypeGroups(onSuccess: () => void) {
  const url = `/v2/orm/user_alarmtype_group_map/alarmtype_group`;

  const request = new Request(url, {
    method: 'PATCH',
  });

  return useAuthenticatedMutation<
    null,
    ModifyUserAlarmTypeGroupsPayload | null
  >(request, {
    onSuccessInvalidationKeys: [['users']],
    onSuccess,
  });
}
